module.exports = __webpack_public_path__ + "media/howie.97e185b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/howie-header/howie.svg
// module id = 844
// module chunks = 0